import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

/* eslint-disable react/jsx-no-target-blank */

/** @jsxImportSource @emotion/react */
import { sendAppLinkOnNumber } from "@vc-workspace/data-adapter";
import { Typography } from "@vc-workspace/utils-typography";
import { useState } from "react";
import { containerStyles, communityGrid, communityGridItem, communityImage, communityContent, appLinkContainer, btnStyles } from './maker-vc-community.module.style';
import { AmplitudeEventNames, sendAmplitudeData } from "@vc-workspace/utils-amplitude";
import { PageTypes } from "@vc-workspace/utils-constants";
export function MakerVcCommunity(props) {
  var _useState = useState(''),
      phone = _useState[0],
      setPhone = _useState[1];

  var _useState2 = useState(false),
      getAppLinkSuccess = _useState2[0],
      toggleAppLinkSuccess = _useState2[1];

  var _useState3 = useState(''),
      errorMessage = _useState3[0],
      setErrorMessage = _useState3[1];

  var onSendAppLink = function onSendAppLink() {
    if (!phone || phone.length !== 10) {
      setErrorMessage('Please enter a valid phone number');
      setTimeout(setErrorMessage, 5000);
    }

    sendAmplitudeData(AmplitudeEventNames.APP_LINK_REQUESTED, {
      source: PageTypes.MAKER
    });
    sendAppLinkOnNumber(phone).then(function () {
      toggleAppLinkSuccess(true);
    })["catch"](function (err) {
      var _err$response, _err$response$data;

      setErrorMessage(err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.message);
      setTimeout(setErrorMessage, 5000);
    });
  };

  return _jsxs("div", {
    css: containerStyles,
    children: [props.context.isMobileView ? null : _jsxs("div", {
      css: appLinkContainer,
      children: [_jsx(Typography, {
        type: "Headline_H1",
        color: "heavy_metal",
        className: "text-center",
        bold: true,
        children: "Get access to millions of customers on Vibecity!"
      }), _jsx("a", {
        target: "_blank",
        href: "https://seller.vibecity.com",
        children: _jsx(Typography, {
          type: "SubHeading1",
          color: "white",
          css: btnStyles,
          inline: true,
          children: "Start Selling"
        })
      })]
    }), _jsxs(Typography, {
      type: props.context.isMobileView ? "Headline_H1" : "Heading2",
      color: "night_rider",
      className: "text-center",
      bold: true,
      children: ["Vibecity Community is always ", props.context.isMobileView ? _jsx("br", {}) : null, "there to help you!"]
    }), _jsx("div", {
      className: !props.context.isMobileView ? "page-container" : "",
      children: _jsxs("div", {
        css: communityGrid,
        children: [_jsxs("div", {
          css: communityGridItem,
          children: [_jsxs("picture", {
            children: [_jsx("source", {
              srcSet: "/_mp-images/vc_community.webp",
              type: "image/webp"
            }), _jsx("img", {
              src: "/_mp-images/vc_community.png",
              css: communityImage
            })]
          }), _jsxs("div", {
            css: communityContent,
            children: [_jsx(Typography, {
              type: "Headline_H1",
              color: "white",
              children: "Seller Community"
            }), _jsx(Typography, {
              type: props.context.isMobileView ? "Body1" : "Headline_H3",
              color: "white",
              className: "pt-2",
              children: "Our rich & vibrant community is made of Creative Enterpreneurs like you. All of us are here to share the best ways to unlock growth"
            })]
          })]
        }), _jsxs("div", {
          css: communityGridItem,
          className: props.context.isMobileView ? "mt-5" : "",
          children: [_jsxs("picture", {
            children: [_jsx("source", {
              srcSet: "/_mp-images/vc_support.webp",
              type: "image/webp"
            }), _jsx("img", {
              src: "/_mp-images/vc_support.png",
              css: communityImage
            })]
          }), _jsxs("div", {
            css: communityContent,
            children: [_jsx(Typography, {
              type: "Headline_H1",
              color: "white",
              children: "Vibecity Support"
            }), _jsx(Typography, {
              type: props.context.isMobileView ? "Body1" : "Headline_H3",
              color: "white",
              className: "pt-2",
              children: "Our support team works 24x7 sincerely to provide the best experience to you & to your customers."
            })]
          })]
        })]
      })
    })]
  });
}
export default MakerVcCommunity;